<template>
  <div>
    <v-dialog
      v-show="registerCreditCardDialog"
      v-model="registerCreditCardDialog"
      persistent
      max-width="600px"
      v-scroll-lock="!registerCreditCardDialog"
    >
      <v-card color="#f5f5f5">
        <v-card-title class="headline">
          Register Credit card
        </v-card-title>
        <div style="padding: 30px;">
          <label for="card-element">
            Credit or debit card
          </label>
          <div id="card-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>
          <div v-if="showResult" class="error--text">{{ resultMessage }}</div>
          <v-btn
            v-if="!processing"
            class="mt-3"
            @click="submit"
            color="primary"
          >
            Register
          </v-btn>
          <v-progress-circular
            v-if="processing"
            class="mt-3 ml-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <v-row class="mt-8" style="margin-left: 30px;">
          <v-btn
            class="mb-5"
            color="error"
            @click="setRegisterCreditCardDialog(false)"
          >
            Close
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'RegisterCreditCardDialog',
  props: {
    registerCreditCardDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showResult: false,
      // eslint-disable-next-line new-cap
      stripe: window.Stripe(process.env.VUE_APP_STRIPE_PK),
      card: null,
      resultMessage: '',
      processing: false,
    }
  },
  methods: {
    setRegisterCreditCardDialog(show) {
      this.$emit('setRegisterCreditCardDialog', show)
    },
    async submit() {
      this.processing = true
      this.showResult = false
      const setupIntentResult = await this.getSetupIntentsSecret()
      if (!setupIntentResult) {
        this.processing = false
        return
      }
      const setupIntentSecret = setupIntentResult.data.ClientSecret
      const result = await this.stripe.confirmCardSetup(setupIntentSecret, {
        payment_method: {
          card: this.card,
        },
      })
      if (result.error) {
        this.showResult = true
        this.resultMessage = result.error.message
        this.processing = false
        return
      }
      const postResult = await this.postSubscriptionPayment(
        result.setupIntent.payment_method
      )
      if (!postResult) {
        this.processing = false
        return
      }
      if (postResult.data.CVCFailure) {
        this.showResult = true
        this.resultMessage = 'Some information is incorrect.'
        this.processing = false
        return
      }
      this.processing = false
      this.$emit('init')
      this.$emit('setRegisterCreditCardDialog', false)
    },
  },
  updated() {
    this.card.mount('#card-element')
  },
  mounted() {
    const elements = this.stripe.elements()
    this.card = elements.create('card')
  },
}
</script>

<style scoped>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
